export {
  BaseSettings,
  BaseSettingsPage,
  BaseSettingsPageSidebar,
  BaseSettingsEmptyResults,
  BaseSettingsTable,
} from './components';
export { useSettingsCloseConfirm } from './composables';
